import { combineReducers } from 'redux-immutable';
import { routerReducer } from 'react-router-redux';
import { reducer as ToastrReducer } from 'react-redux-toastr';

import Auth from './auth';
import QRImages from './qrimages';
import Customer from './customer';
import User from './user';
import Score from './score';
import ScoreExchange from './scoreExchange';
import ScoreLog from './scoreLog';
import Error from './error';
import NewTasks from './newTasks';
import QueryTasks from './queryTasks';

export default combineReducers({
  Auth,
  QRImages,
  Customer,
  User,
  Score,
  Error,
  ScoreLog,
  ScoreExchange,
  NewTasks,
  QueryTasks,
  routerReducer,
  toastr: ToastrReducer
})



// WEBPACK FOOTER //
// ./reducers/index.js